import React from 'react';
const FieldGroup = (props) => {
  return(
    <div {...props}>
      {props.children}
    </div>
  )
}
export default FieldGroup;
